
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/avatar.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-avatar-demo-basic","docs-weet-avatar-demo-color","docs-weet-avatar-demo-size","docs-weet-avatar-demo-load-error"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/avatar.md?type=demo')
};